import { api } from '../utils/api';
import type { Flavor } from '../types/@types/flavor';

interface FlavorApi {
  id: string;
  name: string;
  available: boolean;
  createdAt?: string;
  updatedAt?: string;
}

function mapFlavor(f: FlavorApi): Flavor {
  const { id, ...rest } = f;
  return { id: id, ...rest };
}

export async function getFlavors(): Promise<Flavor[]> {
  const { data } = await api.get<FlavorApi[]>('/flavors');
  return data.map(mapFlavor);
}

export async function createFlavor(
  flavor: Omit<Flavor, 'id' | 'createdAt' | 'updatedAt'>,
): Promise<Flavor> {
  const { data } = await api.post<FlavorApi>('/flavors', flavor);
  return mapFlavor(data);
}

export async function updateFlavor(
  id: string,
  flavor: Omit<Flavor, 'id' | 'createdAt' | 'updatedAt'>,
): Promise<Flavor> {
  const { data } = await api.put<FlavorApi>(`/flavors/${id}`, flavor);
  return mapFlavor(data);
}

export async function deleteFlavor(id: string): Promise<void> {
  await api.delete(`/flavors/${id}`);
}
